<template>
  <div class="covid-row d-sm-none">
     India Covid Summery<br> {{covid_data.TotalDeaths|comma}} Deaths out of {{covid_data.TotalConfirmed|comma}} Total Cases.
  </div>
</template>

<script>
import moment from 'moment';
  export default {
    name: 'Covid',

    data: () => ({
      api_key: 'd7b8e164e93545099bc5803b1c156e9e',
      url_base: 'https://api.covid19api.com/summary',
      query:'Delhi',
      covid:[],
      covid_data:{},
      
    }),
    created () {
      this.fetchCovid('Enter');
    },
    methods:{
        fetchCovid(){
            fetch(`${this.url_base}`).then(
                res => {
                    return res.json();
                }).then(this.setResults);
                
            
        },
        setResults(results){
            this.covid = results;
            this.covid_data = this.covid.Countries.find((item) => 
             item.Country === 'India'
            //  console.log(country)
          )
        },
        dateBuilder(d){
            return  moment(d).format('llll');
        },
        number(x) {
          return x.toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    }
  }
</script>

<style scoped>
.covid-row{
    background: #101010;
    color: #fff;
    margin-top: -7px;
    padding: 14px;
    text-align: center;
}
</style>